import { Component, OnInit, AfterViewInit, ChangeDetectorRef, ViewEncapsulation, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
// import { ParentService } from '../_services/parent.service';
// import { StudentService } from '../_services/student.service';
import { DataService } from 'src/app/dashboard/_services/data.service';
import { StaffService } from '../../school-management/_services/staff.service';
import { Subscription, forkJoin, Observable, Subject } from 'rxjs';
import { ControlDeletionService } from 'src/app/_services/control-deletion.service';
import { GlobalService } from 'src/app/_services/global.service';
// import { Filter } from '../_model/filter.model';
import { MessagesControlService } from 'src/app/_services/messages-control.service';
import { ControlActivationService } from 'src/app/_services/control-activation.service';
import { ControlQrService } from 'src/app/_services/control-qr.service';
import { TranslateService } from '@ngx-translate/core';
import { Sorting } from 'src/app/user-management/_model/sorting.model';
import { Filter } from 'src/app/user-management/_model/filter.model';
import { RequestsService } from 'src/app/user-management/_services/requests.service';
import { StudentService } from 'src/app/user-management/_services/student.service';
import { ParentService } from 'src/app/user-management/_services/parent.service';
import { NgxWavesurferService } from 'ngx-wavesurfer';
import { NgxWavesurferRxjsService, WaveSurferRxJSEventObservables } from 'ngx-wavesurfer-rxjs';
import { map, takeUntil } from "rxjs/operators";
import { HttpEventType } from '@angular/common/http';
import { AutoUnsubscribe } from 'src/app/shared/decorators/auto-unsubscribe.decorator';


declare var $: any;
@AutoUnsubscribe
@Component({
  selector: 'app-names-sounds',
  templateUrl: './names-sounds.component.html',
  styleUrls: ['./names-sounds.component.scss']
})
export class NamesSoundsComponent implements OnInit, AfterViewInit {

  filterStatus = false;
  students = [];
  searchText: string;
  filterValues: Filter;
  controlType: string = 'name-sounds';
  listType: string;
  compactView: boolean;
  noResultsFlag: boolean = false;
  rowsNumberToBeShowed: number;
  rowsSubscription;
  resetSubscription;
  searchSubscription;
  filterSubscription;
  // AllRowsIsChecked: boolean;
  selectedCheckBoxes = [];
  test: any = []
  from: number;
  to: number;
  total: number;
  nextPage: number;
  prevPage: number;
  currentPage: number;
  lastPage: number;
  sorting: Sorting;
  loading: boolean;
  request_number: number;
  editFlags = [];
  grades: any = [];
  currLang;
  studentImage;
  studentName;
  studentId;
  studentIndex;
  waveSurfer: WaveSurfer;
  waveSurferRxJS: WaveSurferRxJSEventObservables = {};
  soundType;
  aiFlag: boolean = true;
  recordFlag: boolean = false;
  uploadFlag: boolean = false;
  isPlayingFlag: boolean = false;
  progress$: Observable<number>;
  destroy$ = new Subject<void>(); 
  constructor(
    private globalService: GlobalService,
    private controlActivation: ControlActivationService,
    private messageControl: MessagesControlService,
    private controlDeletion: ControlDeletionService,
    private dataService: DataService,
    private studentService: StudentService,
    private router: Router,
    private translate: TranslateService,
    public waveSurferService: NgxWavesurferService,
    public waveSurferRxJSService: NgxWavesurferRxjsService,
    private ref: ChangeDetectorRef
  ) {
    this.globalService.getLang().pipe(takeUntil(this.destroy$)).subscribe(lng => {
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
    this.rowsSubscription = new Subscription();
    this.resetSubscription = new Subscription();
    this.searchSubscription = new Subscription();
    this.filterSubscription = new Subscription();




    let reloadFlag = localStorage.getItem("relaod");
    if (reloadFlag == 'true') {
      localStorage.setItem("relaod", 'false');
      window.location.reload();
    }
  }

  ngOnDestroy(): void {
    this.rowsSubscription.unsubscribe();
    this.resetSubscription.unsubscribe();
    this.searchSubscription.unsubscribe();
    this.filterSubscription.unsubscribe();
    this.dataService.toggleFilterStatus(false);
    this.waveSurferRxJSService.unsubscribeAll();
  }

  ngOnInit() {
    this.globalService.getLang().pipe(takeUntil(this.destroy$)).subscribe(lng => {
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
    this.globalService.startLoading();
    this.dataService.setFilterValue(new Filter());
    this.request_number = 0;
    this.controlDeletion.toggleDeleteBtn(false);
    this.messageControl.toggleMessageBtn(false);
    this.currentPage = 1;
    this.sorting = {
      name: 'asc',
      grade: null,
      class: null
    }
    this.filterValues = new Filter();
    this.filterValues.grades = [];
    this.filterValues.classes = [];

    this.globalService.getLoading().pipe(takeUntil(this.destroy$)).subscribe(res => {
      this.loading = res;
    })

    this.dataService.getFilterStatus().pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      this.filterStatus = res;
    })

    this.controlActivation.getToggleUserBtn().pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      if (Object.keys(res).length > 0) {
        res.source.checked = !res.checked;
      }
    })

    this.dataService.getRowsStyle().pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      this.compactView = res;
    })

    let r = this.controlDeletion.getResetSelectedRows().subscribe(res => {
      this.selectedCheckBoxes = res === true ? [] : this.selectedCheckBoxes;
    })
    this.resetSubscription.add(r);

    let s = this.dataService.getRowsNumberShown().subscribe(res => {
      // the user changed the rows number not editing
      if (this.rowsNumberToBeShowed !== res) {
        this.currentPage = 1;
      }
      if (res < this.rowsNumberToBeShowed) {
        this.selectedCheckBoxes = this.selectedCheckBoxes.splice(0, res)
      }
      // this.selectedCheckBoxes = [];
      this.rowsNumberToBeShowed = res;
      // this.AllRowsIsChecked = false;
      // this.dataService.setSearchText(null);
      // this.controlDeletion.toggleDeleteBtn(false);
      // this.messageControl.toggleMessageBtn(false);
      this.showList();
    })
    this.rowsSubscription.add(s);

    let x = this.dataService.getSearchText().subscribe(res => {
      if (res !== null) {
        this.selectedCheckBoxes = [];
        this.searchText = res;
        this.currentPage = 1;
        // this.AllRowsIsChecked = false;
        this.controlDeletion.toggleDeleteBtn(false);
        this.messageControl.toggleMessageBtn(false);
        this.showList();
      }
    })
    this.searchSubscription.add(x);

    let f = this.dataService.getFilterValue().subscribe((res: any) => {
      this.currentPage = 1;
      this.filterValues = res;
      // this.filterValues.view = this.controlType;
      this.filterValues.grades != undefined ? this.filterValues.grades = this.filterValues.grades.map(grade => grade['id']):''
      this.filterValues.classes != undefined ? this.filterValues.classes = this.filterValues.classes.map(Clazz => Clazz['id']):''
      // this.AllRowsIsChecked = false;
      this.selectedCheckBoxes = [];
      this.controlDeletion.toggleDeleteBtn(false);
      this.messageControl.toggleMessageBtn(false);
      if (Object.keys(this.filterValues).length !== 0) {
        this.showList();
      }
    })
    this.filterSubscription.add(f);

    this.dataService.getGrades().pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      this.grades = res;
    });
  }
  ngAfterViewInit(): void {
  }

  showList() {
    this.globalService.startLoading();
    this.request_number = this.request_number + 1;
    this.studentService.getStudents(this.rowsNumberToBeShowed, this.currentPage, this.sorting, this.searchText, this.filterValues, this.request_number)
      .pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
        this.test = res.data;
        // let isLng;
        // if(this.currLang=='en'){
        //   isLng=false;
        // }
        // else{
        //   isLng=true;
        // }
        // console.log(this.test);
        setTimeout(() => {
          res.data.forEach(element => {
            let id = element.id;
            if (element.audio_files[0]) {
              this.waveSurfer = this.waveSurferService.create({
                container: `#S${id}` + "",
                height: 64,
                barWidth: .5,
                barHeight: 2.5,
                barMinHeight: 1.5,
                barGap: 4,
                progressColor: '#4ca4f8',
                cursorColor: '#1564a9',
                cursorWidth: 2,
                // rtl:isLng,
              });
              this.waveSurfer.load(
                element.audio_files[0].media_url
              );
              element.wave = this.waveSurfer;
              // element.waveSurferRxJS=this.waveSurferRxJSService.getRxJSWave(element.wave)
            }
          })
        }, 50);


        this.noResultsFlag = false;
        if (this.request_number == res.request_number) {
          this.students = res.data;
          if (this.students.length == 0) {
            this.noResultsFlag = true;
          }
          this.from = res.from;
          this.to = res.to;
          this.total = res.total;
          this.lastPage = res.last_page;
          this.globalService.stopLoading();
        }
      })
  }

  getImage(imagePath: string) {
    return environment.img_url + imagePath;
  }

  previousBtnHandler() {
    if (this.currentPage > 1) {
      this.currentPage = this.currentPage - 1;
      this.showList()
    }
  }

  nextBtnHandler() {
    if (this.currentPage < this.lastPage) {
      this.currentPage = this.currentPage + 1;
      this.showList();
    }
  }

  toggleSorting(sortingBy: string) {
    let previousValuesOfSorting = this.sorting;
    this.sorting = {
      name: null,
      grade: null,
      class: null
    }
    this.sorting[sortingBy] = previousValuesOfSorting[sortingBy] === 'asc' ? 'desc' : 'asc';
    this.showList();
  }



  getId(name) {
    let hashName = `S${name}`;
    return hashName

  }

  recordVoice(e, student, index) {
    if (e) {
      e.stopPropagation();
    }
    this.recordFlag=false;
    // this.studentService.getStudentById(student.id).subscribe(res => {
    this.studentImage = student['image_path'];
    this.studentName = student['name'];
    this.studentId = student['id'];
    this.recordFlag = student?.audio_files[0]?.custom_properties?.type=='recorded'?true:false;
    this.studentIndex = index;
    $('#recordModal').modal("show");
    // })
  }

  uploadVoice(e, student) {
    e.stopPropagation();
    setTimeout(() => {
      $(`#${student.id}`).click();
    }, 50);
  }

  deleteVoice(e, student) {
    e.stopPropagation();
    // to stop the wave in case of deleteing the uploaded voice
    let wave = student.wave;
    if (wave.isPlaying()) {
      wave.stop();
    }
    this.studentService.deleteStudentAudio(student.id, student.audio_files[0].id).pipe(takeUntil(this.destroy$)).subscribe(() => {

    }, err => {
      console.log(err);

    }, () => {
      this.showList();
    })
  }
  playPause(e, student) {

    e.stopPropagation();

    let wave = student.wave;

    wave.playPause();

    this.checkPlaying(wave, student);

  }

  checkPlaying(wave, student) {
    if (wave.isPlaying()) {
      student.isPlayingFlag = true;
    }
    else {
      student.isPlayingFlag = false;
    }
    setTimeout(() => {
      this.checkPlaying(wave, student);

    }, 500);
  }


  onFileInput(event, student) {
    let file = event.target.files[0];
    if (file) {
      // To validate the uploaded file format to only allow mp3 wav ogg oga wma m4a
      let val = file.name.toLowerCase();
      let regex = new RegExp("(.*?)\.(mp3|wav|ogg|oga|wma|m4a)$");
      if (!(regex.test(val))) {
        setTimeout(() => {
          alert(this.translate.instant('names-sounds.unsupported-format'));
        }, 50);
      }
      else {
        this.uploadAudio(file, student);
        student.uploadFlag = true;
        student.uploadStarted = true;
        student.fileName = file.name;
      }
    }
  }

  uploadAudio(file, student) {
    const formData = new FormData();
    formData.append('audio_file', file);
    formData.append('upload_type', 'uploaded');
    student.sub = this.studentService.uploadStudentAudio(student.id, formData)
      .pipe(map(event => {
        if (event.type == HttpEventType.UploadProgress) {
          student.barWidth = Math.round((100 / (event.total || 0) * event.loaded))
          this.ref.detectChanges();
        }
        else if (event.type == HttpEventType.Response) {
          student.barWidth = '0%'
          this.showList();
        }
      }))
      .subscribe(res => {
      },
        (err => {
          student.uploadFialed=true;
          console.log(err);

        }), () => {

        });
  }

  navigatehandling(event) {
    switch (event) {
      case 'reload':
        this.request_number--;
        // to automatically paginate to the next student when recording is done 
        if (this.studentIndex == this.students.length - 1) {
          this.studentIndex = -1;
        }
        this.recordVoice(null, this.students[this.studentIndex + 1], this.studentIndex + 1);
        this.showList();
        break;
      case 'next':
        if (this.studentIndex == this.students.length - 1) {
          this.studentIndex = -1;
        }
        this.recordVoice(null, this.students[this.studentIndex + 1], this.studentIndex + 1);
        break;
      case 'back':
        if (this.studentIndex == 0) {
          this.studentIndex = this.students.length;
        }
        this.recordVoice(null, this.students[this.studentIndex - 1], this.studentIndex - 1);
        break;
      default:
        break;
    }
  }

  confirmReload(){
    // propmt to confirm reload in case of upload failed so the wave can appear again 
    confirm("Are you sure you want to reload ? any ongoing uploads will be cancelled")?this.showList():''

  }
  // cancelUpload(student){
  //   student.sub.unsubscribe();
  //   student.uploadFlag=false;
  //   student.uploadStarted=false;
  //   // this.showList();
  // }

}
